<template>
    <div class="p-col-12 p-md-10 p-md-offset-1 p-align-center p-card p-shadow-3">
        <div class="p-grid p-align-start vertical-container" v-show="this.IsDataLoaded">
            <div class="p-col-4 p-grid p-mt-2">
                <h6><i class="p-ml-2 pi pi-user p-mr-2" />{{ $t('bets.ticketHeaderAccountInfo') }}</h6>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ $t('bets.channel') }}</div>
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ getTicketChannel() }}</div>
                </div>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ $t('bets.placeDate') }}</div>
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ formatCSDateAndTime(ticketContent.ticketDate) }}</div>
                </div>
            </div>
            <div class="p-col-4 p-grid p-mt-2">
                <h6><i class="p-ml-2 pi pi-wallet p-mr-2" />{{ $t('bets.ticketHeaderStakeInfo') }}</h6>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">{{ $t('bets.playedAmount') }}</div>
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">{{ formatCurrency(ticketContent.playedAmount) }}</div>
                </div>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">{{ $t('bets.stakeAmount') }}</div>
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">{{ formatCurrency(ticketContent.stakeAmount) }}</div>
                </div>
            </div>
            <div class="p-col-4 p-grid p-mt-2">
                <h6><i class="p-ml-2 pi pi-dollar p-mr-2" />{{ $t('bets.ticketHeaderBetInfo') }}</h6>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">{{ $t('general.status') }}</div>
                    <div class="p-col-6 p-mt-0 p-mb-0 p-pt-0 p-pb-1">
                        <Button :label="$t('bets.status.' + getTicketStatusName(ticketContent.status))" :class="'p-button-text  p-button-' + getTicketStatusColor(ticketContent.status) + ' p-pt-0 p-pb-0 p-ml-0 p-pl-0'" />
                    </div>
                </div>
                <div class="p-col-12 p-grid p-mt-0 p-mb-0 p-pt-0 p-pb-0">
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ $t('bets.winAmount') }}</div>
                    <div class="p-col-6 p-pt-0 p-pb-1">{{ notNullOrEmptyObject(ticketContent.winInfo) ? formatCurrency(ticketContent.winInfo.winAmount) : 0 }}</div>
                </div>
            </div>
            <hr />
            <Panel class="p-col-12">
                <table class="p-col-12 p-align-center p-card p-shadow-3">
                    <thead>
                        <tr class="p-text-bold">
                            <td>{{ $t('general.no') }}</td>
                            <td>{{ $t('virtuals.roundNo') }}</td>
                            <td>{{ $t('bets.result') }}</td>
                            <td>{{ $t('bets.jackpotCode') }}</td>
                            <td>{{ $t('bets.jackpotAmount') }}</td>
                            <td>{{ $t('bets.stakeAmount') }}</td>
                            <td>{{ $t('bets.winAmount') }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ticketLine, index) in ticketContent.subs" :key="ticketContent.ticketSerial + 'Roundline_' + index">
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{ index + 1 }}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{ ticketLine.roundNo  }}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{ ticketLine.roundMultiplier }}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{  ticketLine.jackpotInfo.jackpotCode }}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{  formatCurrency(ticketLine.jackpotInfo.jackpotValue)}}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{  formatCurrency(ticketLine.bet.betStakeAmount) }}</td>
                            <td class="p-mt-2 p-mb-2 p-pt-2">{{ formatCurrency(ticketLine.winAmount) }}</td>
                        </tr>
                    </tbody>
                </table>
            </Panel>
        </div>
        <div class="p-col-12 p-text-center" v-show="!this.IsDataLoaded && !this.showNoTicket">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
    </div>
</template>
<script>
import { BoTicketsApi } from '../../../service/BoTicketsApi';
import settings from '../../../settings/generalSettings';
export default {
    name: 'rocketTicketDetails',
    emits: ['checkPayment'],
    props: {
        ticketSerial: {
            type: String,
        },
        forPay: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            BoTicketsApi: new BoTicketsApi(),
            ticketContent: [],
            IsDataLoaded: false,
            showNoTicket: false,
        };
    },
    beforeMount() {
        this.getTicketContent();
    },
    methods: {
        getTicketContent() {
            this.BoTicketsApi.getTicketContent(this.ticketSerial)
                .then((response) => {
                    this.ticketContent = response.data;
                    this.IsDataLoaded = true;
                    if (this.forPay) {
                        this.$emit('checkPayment', this.ticketContent.status);
                    }
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                    this.showNoTicket = true;
                    this.IsDataLoaded = false;
                });
        },
        getTicketChannel() {
            var response = '';
            if (this.notNullOrEmptyField(this.ticketContent.cashierId)) {
                response = this.$t('bets.channelCashier');
            } else {
                response = this.$t('bets.channelTerminal');
            }
            return response;
        },
        getLineStatus(ticketStatus, lineWin) {
            if (ticketStatus == 2 || ticketStatus == 5) {
                return ticketStatus;
            } else {
                return lineWin > 0 ? 1 : 0;
            }
        },
        getBetValue(ticketLine) {
            if (this.ticketSerial.substring(0, 2) == settings.ticketType.roulette) {
                return this.notNullOrEmptyField(ticketLine.numbers) ? ticketLine.specialBetType + ' : ' + ticketLine.numbers : ticketLine.specialBetType;
            } else {
                return this.notNullOrEmptyField(ticketLine.numbers) ? ticketLine.numbers.join(',') : this.$t('virtuals.betTypes.' + ticketLine.specialBetType) + ':' + this.$t('virtuals.betTypes.' + ticketLine.specialBetValue);
            }
        },
    },
};
</script>

